/* ============================================================
   MyPokea — site chrome (header + topbar + footer + tweaks)
   Nav items injected by Liquid via window.MYPOKEA_NAV
   ============================================================ */

const FALLBACK_NAV = [
  { href: "/",                    key: "nav.home",       label: "Accueil",        match: ["/", ""] },
  { href: "/pages/pokedex",       key: "nav.shop",       label: "Finger Puppet",  match: ["/pages/pokedex", "/pages/boites"], mega: "shop" },
  { href: "/pages/speciales",     key: "nav.specials",   label: "Spéciales",      match: ["/pages/speciales"], mega: "specials" },
  { href: "/pages/peluches",      key: "nav.plush",      label: "Peluches",       match: ["/pages/peluches"] },
  { href: "/pages/ma-collection", key: "nav.collection", label: "Ma Collection",  match: ["/pages/ma-collection"] },
];

const NAV_ITEMS = (window.MYPOKEA_NAV && window.MYPOKEA_NAV.items && window.MYPOKEA_NAV.items.length > 0 && window.MYPOKEA_NAV.items) || FALLBACK_NAV;

var GEN_PAGE_HANDLE = { 1: 'pokedex-kanto', 2: 'pokedex-johto', 3: 'pokedex-hoenn', 4: 'pokedex-sinnoh', 5: 'pokedex-unys', 6: 'pokedex-kalos', 7: 'pokedex-alola', 8: 'pokedex-galar', 9: 'pokedex-paldea' };
function genPageUrl(gen, extraQuery) {
  const base = GEN_PAGE_HANDLE[gen] ? '/pages/' + GEN_PAGE_HANDLE[gen] : '/pages/pokedex?gen=' + gen;
  if (!extraQuery) return base;
  return base + (base.indexOf('?') === -1 ? '?' : '&') + extraQuery;
}

/* ----- Mega-menu data (sourced from data.js; safe fallbacks) ----- */
function megaGens()     { return (window.POKE && POKE.GENERATIONS) ? POKE.GENERATIONS : []; }
function megaSpecials() { return (window.POKE && POKE.SPECIALS) ? POKE.SPECIALS.filter(c => !c.boutique) : []; }
const pad2 = n => String(n).padStart(2, "0");

function megaPanelHTML(kind) {
  if (kind === "shop") {
    const gens = megaGens();
    return `
      <div class="nav-mega" data-mega="shop">
        <div class="nav-mega-inner">
          <div class="nav-mega-head">
            <span class="nav-mega-eyebrow">Finger puppets · par génération</span>
            <a class="nav-mega-all" href="/pages/pokedex">Tout le catalogue →</a>
          </div>
          <div class="mega-gen-grid">
            ${gens.map(g => `
              <a class="mega-gen ${g.upcoming ? 'soon' : ''}" href="${g.upcoming ? '#' : genPageUrl(g.gen)}" style="--gc:${g.color}; --gd:${g.deep || g.color};">
                <span class="mega-gen-num">${pad2(g.gen)}</span>
                <span class="mega-gen-body">
                  <span class="mega-gen-name">${g.name.length > 9 ? g.name.replace('Génération', 'Gén.') : g.name}<span class="mega-gen-jp">${g.kanji}</span></span>
                  <span class="mega-gen-meta">${g.upcoming ? 'Bientôt' : g.count + ' figurines'}</span>
                </span>
              </a>`).join("")}
          </div>
          <a class="mega-feature" href="/pages/boites">
            <span class="mega-feature-num" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z"/><path d="m3 7.5 9 4.5 9-4.5"/><path d="M12 12v9"/></svg></span>
            <span class="mega-feature-body">
              <span class="mega-feature-name">Boîtes neuves</span>
              <span class="mega-feature-meta">Coffrets &amp; displays scellés d'usine — pièces de collection</span>
            </span>
            <span class="mega-feature-badge">Neuf scellé</span>
            <span class="mega-feature-arrow" aria-hidden="true">→</span>
          </a>
          <a class="mega-feature" href="/pages/speciales?cat=pikachu" style="--gc:var(--sun); --gd:var(--sun-deep);">
            <span class="mega-feature-num" aria-hidden="true" style="font-family:var(--font-jp); font-size:20px; line-height:1;">ピ</span>
            <span class="mega-feature-body">
              <span class="mega-feature-name">Collection Pikachu</span>
              <span class="mega-feature-meta">Toutes éditions &amp; costumes · figurines doigt officielles</span>
            </span>
            <span class="mega-feature-badge">Mascotte</span>
            <span class="mega-feature-arrow" aria-hidden="true">→</span>
          </a>
        </div>
      </div>`;
  }
  if (kind === "specials") {
    const specials = megaSpecials();
    return `
      <div class="nav-mega" data-mega="specials">
        <div class="nav-mega-inner">
          <div class="nav-mega-head">
            <span class="nav-mega-eyebrow">Collections spéciales · séries Bandai</span>
            <a class="nav-mega-all" href="/pages/speciales">Tout voir →</a>
          </div>
          <div class="mega-spec-grid">
            ${specials.map(c => `
              <a class="mega-spec" href="/pages/speciales?cat=${c.id}" style="--gc:${c.color}; --gd:${c.accentDeep || c.color};">
                <span class="mega-spec-dot" aria-hidden="true"></span>
                <span class="mega-spec-body">
                  <span class="mega-spec-name">${c.name}<span class="mega-spec-jp">${c.kanji}</span></span>
                  <span class="mega-spec-tag">${c.tagline}</span>
                </span>
                <span class="mega-spec-meta">${c.figures.length} réf.</span>
              </a>`).join("")}
          </div>
        </div>
      </div>`;
  }
  return "";
}

function megaMobileLinks(kind) {
  if (kind === "shop") {
    return megaGens().map(g => `<a href="${g.upcoming ? '#' : genPageUrl(g.gen)}" class="mobile-link mobile-sublink">↳ ${g.name}${g.upcoming ? ' · bientôt' : ''}</a>`).join("")
      + `<a href="/pages/boites" class="mobile-link mobile-sublink">↳ Boîtes neuves</a>`;
  }
  if (kind === "specials") {
    return megaSpecials().map(c => `<a href="/pages/speciales?cat=${c.id}" class="mobile-link mobile-sublink">↳ ${c.name}</a>`).join("");
  }
  return "";
}

function currentPage() {
  return location.pathname;
}

function navLabel(n) {
  if (n.key && typeof t === "function" && t(n.key) !== n.key) return t(n.key);
  return n.label || (n.key ? t(n.key) : "");
}

function navIsActive(n) {
  if (typeof n.active === "boolean") return n.active;
  const cur = currentPage();
  if (n.match) return n.match.some(m => cur === m || cur.startsWith(m + "?"));
  if (n.mega) return false;
  return cur === n.href;
}

/* ── Recherche globale avec fuzzy matching ── */
let _srchIdx = null;
function _srchNorm(s) {
  return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]/g,'');
}
function _buildSrchIdx() {
  if (_srchIdx) return _srchIdx;
  if (!window.POKE || !POKE.GENERATIONS) return null;
  _srchIdx = [];
  // Base Pokémon from all gens
  const baseMap = new Map(); // normalized name → {id, gen, realName}
  POKE.GENERATIONS.forEach(g => {
    try {
      POKE.genFigures(g.gen).forEach(f => {
        _srchIdx.push({ name: f.name, id: f.num, gen: g.gen, qName: f.name });
        baseMap.set(_srchNorm(f.name), { id: f.num, gen: g.gen, realName: f.name });
      });
    } catch {}
  });
  // Augment with form names from product arrays (Méga / Shiny / Gigamax …)
  const allRaws = [
    'KANTO','JOHTO','HOENN','SINNOH','UNYS','KALOS','ALOLA','GALAR','PALDEA',
    'SHINY','GIGAMAX','PIKACHU','TRANSPARENTES','TERASTAL','MEGAEVO','ULTRABEAST'
  ].flatMap(k => window[k + '_PRODUCTS_RAW'] || []);
  // Sort longest-base-name first so the most specific match wins
  const sortedBases = [...baseMap.entries()].sort((a,b) => b[0].length - a[0].length);
  const seenNorm = new Set(_srchIdx.map(e => _srchNorm(e.name)));
  for (const p of allRaws) {
    if (!p.t) continue;
    const pn = _srchNorm(p.t);
    if (seenNorm.has(pn)) continue;
    seenNorm.add(pn);
    for (const [bn, base] of sortedBases) {
      if (bn.length >= 4 && pn.includes(bn)) {
        _srchIdx.push({ name: p.t, id: base.id, gen: base.gen, qName: base.realName });
        break;
      }
    }
  }
  return _srchIdx;
}
function _lev(a, b) {
  if (Math.abs(a.length - b.length) > 5) return 99;
  const dp = Array.from({length: a.length+1}, (_,i) => Array.from({length: b.length+1}, (_,j) => i||j));
  for (let i=1;i<=a.length;i++) for (let j=1;j<=b.length;j++)
    dp[i][j] = a[i-1]===b[j-1] ? dp[i-1][j-1] : 1+Math.min(dp[i-1][j],dp[i][j-1],dp[i-1][j-1]);
  return dp[a.length][b.length];
}
/* ── Recherche par type (ex. "spectre" → tous les Pokémon de type Spectre) ──
   Données de types disponibles uniquement pour Kanto/Johto/Hoenn (POKE.GEN1-3) ;
   les générations 4+ n'ont pas encore de types renseignés dans data.js. */
let _typeIdMap = null;
function _buildTypeIdMap() {
  if (_typeIdMap) return _typeIdMap;
  _typeIdMap = new Map(); // id → [types]
  if (window.POKE) {
    [POKE.GEN1, POKE.GEN2, POKE.GEN3].forEach(list => {
      (list || []).forEach(p => { if (p && p.types) _typeIdMap.set(p.id, p.types); });
    });
  }
  return _typeIdMap;
}
function _matchTypeKey(q) {
  if (!window.POKE || !POKE.TYPES) return null;
  const qn = _srchNorm(q);
  if (qn.length < 3) return null;
  for (const [key, def] of Object.entries(POKE.TYPES)) {
    if (_srchNorm(key) === qn || _srchNorm(def.label) === qn) return key;
  }
  return null;
}
function _srchQuery(q) {
  const idx = _buildSrchIdx(); if (!idx || !q || q.length < 2) return [];
  const typeKey = _matchTypeKey(q);
  if (typeKey) {
    const typeMap = _buildTypeIdMap();
    const res = [];
    const seenName = new Set();
    for (const p of idx) {
      const types = typeMap.get(p.id);
      if (!types || !types.includes(typeKey)) continue;
      const pn = _srchNorm(p.name);
      if (seenName.has(pn)) continue;           // évite les vrais doublons de nom, garde toutes les formes/variantes
      seenName.add(pn);
      res.push({ ...p, sc: 0 });
    }
    return res.sort((a, b) => a.id - b.id || a.name.localeCompare(b.name)).slice(0, 60);
  }
  const qn = _srchNorm(q);
  const words = q.trim().split(/\s+/).map(_srchNorm).filter(w => w.length >= 3);
  const res = [];
  for (const p of idx) {
    const pn = _srchNorm(p.name);
    let sc = 99;
    if (pn.startsWith(qn))                                                             sc = 0;
    else if (pn.includes(qn))                                                          sc = 1;
    else if (words.length > 1 && words.every(w => pn.includes(w)))                     sc = 1;
    else if (words.some(w => w.length >= 4 && (pn.startsWith(w) || pn.includes(w))))   sc = 2;
    else {
      const lv = _lev(qn, pn.slice(0, Math.min(pn.length, qn.length + 3)));
      if (lv <= Math.max(2, Math.floor(qn.length/3) + 1)) sc = 3 + lv;
      if (sc === 99) for (const w of words) {
        const wlv = _lev(w, pn.slice(0, Math.min(pn.length, w.length + 2)));
        if (wlv <= Math.max(1, Math.floor(w.length/3) + 1)) { sc = 3 + wlv; break; }
      }
    }
    if (sc < 99) res.push({...p, sc});
  }
  return res.sort((a,b) => a.sc-b.sc||a.name.localeCompare(b.name)).slice(0,8);
}
function _initGlobalSearch(input, dropdown) {
  const q0 = new URL(location.href).searchParams.get('q');
  if (q0) input.value = q0;
  let _t = null;
  const showDrop = results => {
    if (!dropdown) return;
    if (!results.length) { dropdown.hidden = true; return; }
    dropdown.hidden = false;
    dropdown.innerHTML = results.map(r =>
      `<a class="srch-item" href="${genPageUrl(r.gen, 'q=' + encodeURIComponent(r.qName||r.name))}">
        <span class="srch-num">#${String(r.id).padStart(3,'0')}</span>
        <span class="srch-name">${r.name}</span>
      </a>`).join('');
  };
  const go = () => {
    const q = input.value.trim(); if (!q) return;
    const typeKey = _matchTypeKey(q);
    if (typeKey) {
      // Une recherche par type doit ouvrir le Pokédex filtré sur ce type, pas se
      // rabattre sur le nom du 1er résultat (ça écrasait ce que le client avait
      // tapé et ne montrait plus qu'un seul Pokémon au lieu de tous ceux du type).
      // Les puces de filtre par type existent sur Kanto/Johto/Hoenn (gen 1-3) —
      // on ouvre la génération du 1er Pokémon trouvé pour ce type (numéro le plus bas).
      const typeRes = _srchQuery(q);
      const destGen = typeRes.length ? typeRes[0].gen : 1;
      location.href = genPageUrl(destGen, 'type=' + encodeURIComponent(typeKey));
      return;
    }
    const res = _srchQuery(q);
    location.href = res.length
      ? genPageUrl(res[0].gen, 'q=' + encodeURIComponent(res[0].qName||res[0].name))
      : `/pages/pokedex?q=${encodeURIComponent(q)}`;
  };
  input.addEventListener('input', () => { clearTimeout(_t); _t = setTimeout(()=>showDrop(_srchQuery(input.value.trim())),160); });
  input.addEventListener('keydown', e => { if(e.key==='Enter'){ if(dropdown) dropdown.hidden=true; go(); }});
  input.addEventListener('focus', () => { if(input.value.trim()) showDrop(_srchQuery(input.value.trim())); });
  input.addEventListener('blur', () => setTimeout(()=>{ if(dropdown) dropdown.hidden=true; },200));
  input.addEventListener('search', () => { if(!input.value.trim()&&dropdown) dropdown.hidden=true; });
}

function renderHeader(target = "#site-header") {
  const el = document.querySelector(target);
  if (!el) return;
  const cur = currentPage();
  const brandName = (window.MYPOKEA_NAV && window.MYPOKEA_NAV.shopName) || 'MyPokea';
  const logoUrl = window.MYPOKEA_NAV && window.MYPOKEA_NAV.logoUrl;
  const isLoggedIn = !!(window.MYPOKEA_NAV && window.MYPOKEA_NAV.isLoggedIn);
  const acctLabel = isLoggedIn ? t('nav.account') : t('nav.createAccount');
  el.innerHTML = `
    <div class="site-header">
      <div class="topbar" aria-hidden="false">
        <div class="container topbar-inner">
          <span class="topbar-item"><span class="jp-flag"></span> ${t('top.1')}</span>
          <span class="topbar-dot">·</span>
          <span class="topbar-item">${t('top.2')}</span>
          <span class="topbar-dot">·</span>
          <span class="topbar-item">${t('top.3')}</span>
        </div>
      </div>
      <div class="container site-header-inner">
        <a href="/" class="brand" aria-label="${brandName}">
          ${logoUrl ? `<img class="brand-logo" src="${logoUrl}" alt="${brandName}">` : `<span class="brand-mark" aria-hidden="true"></span><span>${brandName}</span>`}
        </a>
        <nav class="nav-main" aria-label="Navigation">
          ${NAV_ITEMS.map(n => n.mega ? `
            <div class="nav-has-mega">
              <a href="${n.href}" class="nav-link ${navIsActive(n) ? 'active' : ''}" aria-haspopup="true">${navLabel(n)}<svg class="nav-caret" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg></a>
              ${megaPanelHTML(n.mega)}
            </div>
          ` : `
            <a href="${n.href}" class="nav-link ${navIsActive(n) ? 'active' : ''}">${navLabel(n)}</a>
          `).join("")}
        </nav>
        <div class="header-actions">
          <a class="acct-btn" href="/pages/profil" aria-label="${acctLabel}" title="${acctLabel}">
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>
            </svg>
            <span class="acct-btn-label">${acctLabel}</span>
          </a>
          <button class="lang-btn" data-lang-btn aria-label="Langue / Language" title="${(typeof getLang === 'function' ? getLang() : 'fr') === 'en' ? 'Switch to French' : 'Switch to English'}">
            ${(typeof getLang === 'function' ? getLang() : 'fr') === 'en' ? '🇬🇧' : '🇫🇷'}
          </button>
          <button class="cart-btn" data-cart-btn aria-label="${t('cart.label')}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 8h14l-1.5 10.5a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 8Z"/>
              <path d="M9 8V6a3 3 0 0 0 6 0v2"/>
            </svg>
            <span class="cart-btn-label">${t('cart.label')}</span>
            <span class="cart-btn-count" data-cart-count>0</span>
          </button>
          <a class="contact-btn" href="/pages/contact" aria-label="${t('nav.contact')}" title="${t('nav.contact')}">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>
            </svg>
            <span class="contact-btn-label">${t('nav.contact')}</span>
          </a>
          <button class="nav-toggle" data-nav-toggle aria-label="Menu" aria-expanded="false">
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
      <div class="container header-search-row">
        <div class="search-wrap">
          <label class="search-bar" aria-label="Recherche">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3-3"/></svg>
            <input type="search" placeholder="${t('search.ph')}" data-global-search>
          </label>
          <div class="search-dropdown" hidden></div>
        </div>
      </div>
      <div class="mobile-menu" data-mobile-menu>
        <nav class="mobile-nav" aria-label="Navigation mobile">
          ${NAV_ITEMS.map(n => `
            <a href="${n.href}" class="mobile-link ${navIsActive(n) ? 'active' : ''}">${navLabel(n)}</a>
            ${n.mega ? megaMobileLinks(n.mega) : ''}
          `).join("")}
          <a href="/pages/profil" class="mobile-link ${cur === '/pages/profil' ? 'active' : ''}">${acctLabel}</a>
          <a href="/pages/contact" class="mobile-link ${cur === '/pages/contact' ? 'active' : ''}">${t('nav.contact')}</a>
        </nav>
      </div>
    </div>
  `;
  // lang toggle
  el.querySelector("[data-lang-btn]").onclick = () => {
    if (typeof setLang !== 'function' || typeof getLang !== 'function') return;
    setLang(getLang() === 'en' ? 'fr' : 'en');
    location.reload();
  };
  // cart
  el.querySelector("[data-cart-btn]").onclick = () => window.openCart && window.openCart();
  // search
  el.querySelectorAll("[data-global-search]").forEach(input => {
    const wrap = input.closest(".search-wrap");
    const dropdown = wrap && wrap.querySelector(".search-dropdown");
    _initGlobalSearch(input, dropdown);
  });
  // mobile menu toggle
  const toggle = el.querySelector("[data-nav-toggle]");
  const menu = el.querySelector("[data-mobile-menu]");
  toggle.onclick = () => {
    const open = el.classList.toggle("nav-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  };
  menu.querySelectorAll("a").forEach(a => a.addEventListener("click", () => {
    el.classList.remove("nav-open");
    toggle.setAttribute("aria-expanded", "false");
  }));
  // sync cart count after re-render
  if (window.Cart) Cart._notify && Cart._notify();
}

function renderFooter(target = "#site-footer") {
  const el = document.querySelector(target);
  if (!el) return;
  const brandName = (window.MYPOKEA_NAV && window.MYPOKEA_NAV.shopName) || 'MyPokea';
  const logoUrl = (window.MYPOKEA_NAV && window.MYPOKEA_NAV.logoUrlWhite) || (window.MYPOKEA_NAV && window.MYPOKEA_NAV.logoUrl);
  const isLoggedIn = !!(window.MYPOKEA_NAV && window.MYPOKEA_NAV.isLoggedIn);
  const acctLabel = isLoggedIn ? t('nav.account') : t('nav.createAccount');
  const specials = megaSpecials();
  el.innerHTML = `
    <footer class="site-footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="row" style="gap:12px;">
              ${logoUrl ? `<img class="brand-logo" src="${logoUrl}" alt="${brandName}" style="height:88px;width:auto;">` : `<span class="brand-mark" aria-hidden="true" style="width:32px;height:32px;"></span><h3>${brandName}</h3>`}
            </div>
            <p>${t('foot.tagline')}</p>
            <span class="footer-jp"><span class="jp-flag"></span> 日本から · ありがとう</span>
          </div>
          <div class="footer-col">
            <h4>${t('foot.cat')}</h4>
            <ul>
              <li><a href="/pages/pokedex">${t('foot.shop.dex')}</a></li>
              <li><a href="/pages/pokedex-kanto">${t('foot.shop.kanto')}</a></li>
              <li><a href="/pages/boites">${t('nav.boxes')}</a></li>
              <li><a href="/pages/peluches">${t('foot.shop.plush')}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>${t('spec.eyebrow') || 'Spéciales'}</h4>
            <ul>
              ${specials.slice(0, 4).map(c => `<li><a href="/pages/speciales?cat=${c.id}">${c.name}</a></li>`).join("")}
              <li><a href="/pages/speciales">${t('foot.spec.all')}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>${t('foot.help')}</h4>
            <ul>
              <li><a href="/pages/profil">${acctLabel}</a></li>
              <li><a href="/pages/ma-collection">${t('nav.collection')}</a></li>
              <li><a href="/#faq">${t('foot.help.faq')}</a></li>
              <li><a href="/pages/a-propos">À propos</a></li>
              <li><a href="/pages/contact">${t('foot.help.contact')}</a></li>
              <li><a href="/pages/cgv">${t('foot.help.warranty')}</a></li>
            </ul>
          </div>
        </div>
        <div class="footer-disclaimer">${t('foot.disclaimer')}</div>
        <div class="footer-bottom">
          <a href="/pages/a-propos">À propos</a>
          <a href="/pages/cgv">CGV</a>
          <a href="/policies/legal-notice">Mentions légales</a>
          <a href="/policies/privacy-policy">Confidentialité</a>
          <a href="/policies/terms-of-service">Conditions de service</a>
          <a href="/policies/refund-policy">Retours &amp; remboursements</a>
          <a href="/policies/shipping-policy">Livraison</a>
        </div>
      </div>
    </footer>
  `;
}

/* ----------- Tweaks panel ----------- */
const TWEAK_DEFAULTS = {
  "theme": "candy",
  "accent": "sky",
  "density": "comfort",
  "shapes": true
};

function applyTweaks(t) {
  document.documentElement.setAttribute("data-theme", t.theme);
  document.documentElement.setAttribute("data-accent", t.accent);
  document.documentElement.setAttribute("data-density", t.density);
  document.documentElement.toggleAttribute("data-no-shapes", !t.shapes);
}
let TWEAKS = { ...TWEAK_DEFAULTS };
applyTweaks(TWEAKS);

if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

document.addEventListener("DOMContentLoaded", () => {
  if (!location.hash) window.scrollTo(0, 0);
  if (window.applyI18n) applyI18n();
  if (document.querySelector("#site-header")) renderHeader();
  if (document.querySelector("#site-footer")) renderFooter();
  if (window.Cart) Cart.init();
  promotePolicyHeadings();
});

/* Les pages de politiques Shopify natives (/policies/*) n'ont aucun template custom :
   Shopify ne rend que des <p> plats, y compris pour les intitulés de section
   ("ZONES DE LIVRAISON", "ARTICLE 3 - PRIX"...), qui se fondent dans le texte.
   On repère les paragraphes courts entièrement en majuscules et on les transforme
   en vrais <h2> pour restaurer une hiérarchie lisible (voir aussi assets/chrome.css). */
function promotePolicyHeadings() {
  const body = document.querySelector(".shopify-policy__body .rte");
  if (!body) return;
  body.querySelectorAll("p").forEach((p) => {
    const txt = (p.textContent || "").trim();
    if (!txt || txt.length > 70) return;
    if (txt !== txt.toUpperCase()) return;       // pas entièrement en majuscules
    if (!/[A-ZÀ-Ý]/.test(txt)) return;           // doit contenir au moins une lettre
    const h2 = document.createElement("h2");
    h2.textContent = txt;
    p.replaceWith(h2);
  });
}

window.addEventListener("langchange", () => {
  if (document.querySelector("#site-header")) renderHeader();
  if (document.querySelector("#site-footer")) renderFooter();
  if (window.applyI18n) applyI18n();
  if (typeof window.onLangChange === "function") window.onLangChange();
});

/* ----- "Afficher plus" toggle for long seo-text blocks (assets/seo.css .seo-clamp) ----- */
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".seo-more-btn");
  if (!btn) return;
  const clamp = btn.previousElementSibling;
  if (!clamp || !clamp.classList.contains("seo-clamp")) return;
  const expanded = clamp.classList.toggle("expanded");
  btn.textContent = expanded ? "Afficher moins" : "Afficher plus";
  btn.setAttribute("aria-expanded", expanded ? "true" : "false");
});
